import { DropdownListItemInterface } from '~/src/components/form-components/dropdown/dropdown.types';

export const getItemData = (item: string | DropdownListItemInterface): DropdownListItemInterface => {
    if (item instanceof Object) {
        return { ...item } as DropdownListItemInterface;
    }
    return { id: item, value: item };
};